module.exports = __webpack_public_path__ + "img/store-a.587c02ba.svg";